import { ThemeOptions } from '@mui/material';

const lightTheme: ThemeOptions = {
	palette: {
		mode: 'light',
		primary: {
			main: '#111111',
			light: '#42a5f5',
			dark: '#484444',
		},
		textPrimary: undefined,
		textSecondary: undefined,
		textTertiary: undefined,
		textQuaternary: undefined,
		textBrandPrimary: undefined,
		textBrandSecondary: undefined,
		textBrandTertiary: undefined,
		textWhite: undefined,
		textDisabled: undefined,
		textPlaceholder: undefined,
		textError: undefined,
		textWarning: undefined,
		textSuccess: undefined,
		textInfo: undefined,
		bgPrimary: undefined,
		bgPrimaryHover: undefined,
		bgPrimarySolid: undefined,
		bgSecondary: undefined,
		bgSecondaryHover: undefined,
		bgSecondarySolid: undefined,
		bgTertiary: undefined,
		bgQuaternary: undefined,
		bgActive: undefined,
		bgDisabled: undefined,
		bgOverlay: undefined,
		bgBrandPrimary: undefined,
		bgBrandPrimaryAlt: undefined,
		bgBrandSecondary: undefined,
		bgBrandSolid: undefined,
		bgBrandSolidHover: undefined,
		bgBrandSection: undefined,
		bgErrorPrimary: undefined,
		bgErrorSecondary: undefined,
		bgErrorSolid: undefined,
		bgErrorSolidHover: undefined,
		bgWarningPrimary: undefined,
		bgWarningSecondary: undefined,
		bgWarningSolid: undefined,
		bgSuccessPrimary: undefined,
		bgSuccessSecondary: undefined,
		bgSuccessSolid: undefined,
		bgInfoPrimary: undefined,
		bgInfoSecondary: undefined,
		bgInfoSolid: undefined,
		fgPrimary: undefined,
		fgSecondary: undefined,
		fgTertiary: undefined,
		fgQuaternary: undefined,
		fgWhite: undefined,
		fgDisabled: undefined,
		fgBrandPrimary: undefined,
		fgBrandSecondary: undefined,
		fgErrorPrimary: undefined,
		fgErrorSecondary: undefined,
		fgWarningPrimary: undefined,
		fgWarningSecondary: undefined,
		fgSuccessPrimary: undefined,
		fgSuccessSecondary: undefined,
		fgInfoPrimary: undefined,
		fgInfoSecondary: undefined,
		borderPrimary: undefined,
		borderPrimarySolid: undefined,
		borderSecondary: undefined,
		borderSecondarySolid: undefined,
		borderTertiary: undefined,
		borderDisabled: undefined,
		borderBrandPrimary: undefined,
		borderBrandSecondary: undefined,
		borderError: undefined,
		borderWarning: undefined,
		borderSuccess: undefined,
		borderInfo: undefined,
		utilityGray950: undefined,
		utilityGray900: undefined,
		utilityGray800: undefined,
		utilityGray700: undefined,
		utilityGray600: undefined,
		utilityGray500: undefined,
		utilityGray400: undefined,
		utilityGray300: undefined,
		utilityGray200: undefined,
		utilityGray100: undefined,
		utilityGray50: undefined,
		utilityRed950: undefined,
		utilityRed900: undefined,
		utilityRed800: undefined,
		utilityRed700: undefined,
		utilityRed600: undefined,
		utilityRed500: undefined,
		utilityRed400: undefined,
		utilityRed300: undefined,
		utilityRed200: undefined,
		utilityRed100: undefined,
		utilityRed50: undefined,
		utilityOrange950: undefined,
		utilityOrange900: undefined,
		utilityOrange800: undefined,
		utilityOrange700: undefined,
		utilityOrange600: undefined,
		utilityOrange500: undefined,
		utilityOrange400: undefined,
		utilityOrange300: undefined,
		utilityOrange200: undefined,
		utilityOrange100: undefined,
		utilityOrange50: undefined,
		utilityAmber950: undefined,
		utilityAmber900: undefined,
		utilityAmber800: undefined,
		utilityAmber700: undefined,
		utilityAmber600: undefined,
		utilityAmber500: undefined,
		utilityAmber400: undefined,
		utilityAmber300: undefined,
		utilityAmber200: undefined,
		utilityAmber100: undefined,
		utilityAmber50: undefined,
		utilityYellow950: undefined,
		utilityYellow900: undefined,
		utilityYellow800: undefined,
		utilityYellow700: undefined,
		utilityYellow600: undefined,
		utilityYellow500: undefined,
		utilityYellow400: undefined,
		utilityYellow300: undefined,
		utilityYellow200: undefined,
		utilityYellow100: undefined,
		utilityYellow50: undefined,
		utilityLime950: undefined,
		utilityLime900: undefined,
		utilityLime800: undefined,
		utilityLime700: undefined,
		utilityLime600: undefined,
		utilityLime500: undefined,
		utilityLime400: undefined,
		utilityLime300: undefined,
		utilityLime200: undefined,
		utilityLime100: undefined,
		utilityLime50: undefined,
		utilityGreen950: undefined,
		utilityGreen900: undefined,
		utilityGreen800: undefined,
		utilityGreen700: undefined,
		utilityGreen600: undefined,
		utilityGreen500: undefined,
		utilityGreen400: undefined,
		utilityGreen300: undefined,
		utilityGreen200: undefined,
		utilityGreen100: undefined,
		utilityGreen50: undefined,
		utilityEmerald950: undefined,
		utilityEmerald900: undefined,
		utilityEmerald800: undefined,
		utilityEmerald700: undefined,
		utilityEmerald600: undefined,
		utilityEmerald500: undefined,
		utilityEmerald400: undefined,
		utilityEmerald300: undefined,
		utilityEmerald200: undefined,
		utilityEmerald100: undefined,
		utilityEmerald50: undefined,
		utilityTeal950: undefined,
		utilityTeal900: undefined,
		utilityTeal800: undefined,
		utilityTeal700: undefined,
		utilityTeal600: undefined,
		utilityTeal500: undefined,
		utilityTeal400: undefined,
		utilityTeal300: undefined,
		utilityTeal200: undefined,
		utilityTeal100: undefined,
		utilityTeal50: undefined,
		utilityCyan950: undefined,
		utilityCyan900: undefined,
		utilityCyan800: undefined,
		utilityCyan700: undefined,
		utilityCyan600: undefined,
		utilityCyan500: undefined,
		utilityCyan400: undefined,
		utilityCyan300: undefined,
		utilityCyan200: undefined,
		utilityCyan100: undefined,
		utilityCyan50: undefined,
		utilitySky950: undefined,
		utilitySky900: undefined,
		utilitySky800: undefined,
		utilitySky700: undefined,
		utilitySky600: undefined,
		utilitySky500: undefined,
		utilitySky400: undefined,
		utilitySky300: undefined,
		utilitySky200: undefined,
		utilitySky100: undefined,
		utilitySky50: undefined,
		utilityBlue950: undefined,
		utilityBlue900: undefined,
		utilityBlue800: undefined,
		utilityBlue700: undefined,
		utilityBlue600: undefined,
		utilityBlue500: undefined,
		utilityBlue400: undefined,
		utilityBlue300: undefined,
		utilityBlue200: undefined,
		utilityBlue100: undefined,
		utilityBlue50: undefined,
		utilityIndigo950: undefined,
		utilityIndigo900: undefined,
		utilityIndigo800: undefined,
		utilityIndigo700: undefined,
		utilityIndigo600: undefined,
		utilityIndigo500: undefined,
		utilityIndigo400: undefined,
		utilityIndigo300: undefined,
		utilityIndigo200: undefined,
		utilityIndigo100: undefined,
		utilityIndigo50: undefined,
		utilityViolet950: undefined,
		utilityViolet900: undefined,
		utilityViolet800: undefined,
		utilityViolet700: undefined,
		utilityViolet600: undefined,
		utilityViolet500: undefined,
		utilityViolet400: undefined,
		utilityViolet300: undefined,
		utilityViolet200: undefined,
		utilityViolet100: undefined,
		utilityViolet50: undefined,
		utilityPurple950: undefined,
		utilityPurple900: undefined,
		utilityPurple800: undefined,
		utilityPurple700: undefined,
		utilityPurple600: undefined,
		utilityPurple500: undefined,
		utilityPurple400: undefined,
		utilityPurple300: undefined,
		utilityPurple200: undefined,
		utilityPurple100: undefined,
		utilityPurple50: undefined,
		utilityFuchsia950: undefined,
		utilityFuchsia900: undefined,
		utilityFuchsia800: undefined,
		utilityFuchsia700: undefined,
		utilityFuchsia600: undefined,
		utilityFuchsia500: undefined,
		utilityFuchsia400: undefined,
		utilityFuchsia300: undefined,
		utilityFuchsia200: undefined,
		utilityFuchsia100: undefined,
		utilityFuchsia50: undefined,
		utilityPink950: undefined,
		utilityPink900: undefined,
		utilityPink800: undefined,
		utilityPink700: undefined,
		utilityPink600: undefined,
		utilityPink500: undefined,
		utilityPink400: undefined,
		utilityPink300: undefined,
		utilityPink200: undefined,
		utilityPink100: undefined,
		utilityPink50: undefined,
		utilityRose950: undefined,
		utilityRose900: undefined,
		utilityRose800: undefined,
		utilityRose700: undefined,
		utilityRose600: undefined,
		utilityRose500: undefined,
		utilityRose400: undefined,
		utilityRose300: undefined,
		utilityRose200: undefined,
		utilityRose100: undefined,
		utilityRose50: undefined,
		sidebarTextActive: undefined,
		sidebarIconActive: undefined,
	},
};

export default lightTheme;
